<template>
  <div class="export" v-loading="loading">
    <div class="export__header">
      <span class="title">ORDERING FACILITIES REPORT</span>
    </div>
    <div class="export__footer">
      <el-row :gutter="15">
        <el-col :span="24">
          <div class="collapse-header">
            <div class="header-section border-line">
              <ul class="data-include-sub-header">
                <li class="checkbox-sub-header">Data Includes:</li>

                <li class="search-checkbox">
                  <el-checkbox
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                    size="small"
                    >Check All</el-checkbox
                  >
                </li>
              </ul>
              <el-button class="download-btn" @click="downloadHospitals">
                Download
              </el-button>
            </div>
            <div class="date-includes">
              <div class="date-includes">
                <el-checkbox-group
                  v-model="activeFieldList"
                  @change="isCheckAll"
                >
                  <ul class="check-list">
                    <li
                      v-for="(item, index) in exportHospitalsExcelFields"
                      :key="index"
                      class="search-checkbox"
                    >
                      <el-checkbox :label="item.value">
                        {{ item.label }}
                      </el-checkbox>
                    </li>
                  </ul>
                </el-checkbox-group>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import exportExcelHelper from "@/mixins/exportExcelHelper";
export default {
  data() {
    return {
      checkAll: true,
      activeFieldList: [],
      fieldList: [],
      loading: false,
    };
  },
  mixins: [exportExcelHelper],
  mounted() {
    this.checkDefaultExport();
  },
  methods: {
    checkDefaultExport() {
      this.onExportReports();
    },
    onExportReports() {
      this.loadFieldsList();
    },
    handleCheckAllChange(val) {
      this.activeFieldList = val ? this.fieldList : [];
    },
    isCheckAll() {
      if (
        this.activeFieldList &&
        this.exportHospitalsExcelFields &&
        this.activeFieldList.length &&
        this.exportHospitalsExcelFields.length &&
        this.activeFieldList.length == this.exportHospitalsExcelFields.length
      ) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    loadFieldsList() {
      this.exportHospitalsExcelFields.forEach((obj) => {
        this.fieldList.push(obj.value);
      });
      this.activeFieldList = this.fieldList;
    },
    async downloadHospitals() {
      if (this.activeFieldList.length) {
        this.loading = true;

        let params = {
          include: this.activeFieldList,
        };
        if (this.search_string != "") {
          params.search_string = this.search_string;
        }
        await this.$store.dispatch("hospitals/downloadHospitalData", params);
        this.loading = false;
      } else {
        this.$message({
          message: "Please select the data fields.",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
